import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PreparationForUse, RegistrationPreparationForUseModel } from 'shared';

@Injectable()
export class PreparingForUseService {
  readonly apiUrl = '/api/preparation-for-use';

  constructor(private http: HttpClient) {
  }

  registration(data: RegistrationPreparationForUseModel): Observable<PreparationForUse> {
    return this.http.post<PreparationForUse>(`${this.apiUrl}/registration`, data);
  }


}
